var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-alert',{staticStyle:{"margin-bottom":"15px"},attrs:{"type":"warning","title":"以合同签订日期为统计单位对时段范围内的签订的合同金额及数量进行统计"}}),_c('time-statistic',{ref:"timeStatistic"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }